import getters from "./getters"
import actions from "./actions"
import mutations from "./mutations"
import cacheLs from "../cacheLs"

const state = {
  refreshComponentObj: cacheLs.get_refreshComponentObj()
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
